// Função para formatar números de telefone brasileiros, adicionando o nono dígito quando necessário
const formatPhoneNumber = (phoneNumber: string): string => {
    console.log("phoneNumber antes", phoneNumber)
    // Remove todos os caracteres que não são números
    const cleanedNumber = phoneNumber.replace(/\D/g, "");
  
    // Verifica se o número começa com o DDI do Brasil (+55) e se possui 12 dígitos (sem o "9")
    if (cleanedNumber.startsWith("55") && cleanedNumber.length === 12) {
      // Adiciona o "9" após o DDD
      return "55" + cleanedNumber.slice(2, 4) + "9" + cleanedNumber.slice(4);
    }
  
    // Retorna o número como está se já estiver correto
    console.log("phoneNumber depois", cleanedNumber)
    return cleanedNumber;
  };
  
  export default formatPhoneNumber;
  